import DefaultFormSubtitle from "./DefaultFormSubtitle";
import TiFormSubtitle from "./TiFormSubtitle";
import generateRender from 'shared/utils/generateRender';

const FormSubtitle = generateRender({
    default: DefaultFormSubtitle,
    ti: TiFormSubtitle
})

export default FormSubtitle;